import script from "./AudienceManagementEmptyTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./AudienceManagementEmptyTable.vue?vue&type=script&lang=ts&setup=true"

import "./AudienceManagementEmptyTable.vue?vue&type=style&index=0&id=f9c2ad48&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9c2ad48"]])

export default __exports__